import sound from './attack.wav';export default sound;